var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStorefront = function SvgStorefront(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.003 11.62v9.384m2.001 0H1.996m2-9.385v9.385m3.002 0V15.5a.5.5 0 0 1 .5-.5H10a.5.5 0 0 1 .5.5v5.503M20.915 8.999H3.085m10.916 9.004h3.001a.5.5 0 0 0 .5-.5V15.5a.5.5 0 0 0-.5-.5h-3.001a.5.5 0 0 0-.5.5v2.002a.5.5 0 0 0 .5.5ZM7.498 9.749a2.25 2.25 0 1 1-4.502 0v-.127a2.245 2.245 0 0 1 .317-1.157l2.101-3.497a2 2 0 0 1 1.716-.971h9.74c.701.001 1.35.37 1.712.971l2.1 3.497c.21.35.322.75.322 1.157v.127a2.25 2.25 0 0 1-4.502 0 2.25 2.25 0 1 1-4.502 0 2.25 2.25 0 1 1-4.502 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStorefront);
export default ForwardRef;